<template>
  <div class="header list">
    <h3 id="sessionsListTitle">{{ title }}</h3>
    <skeleton
      v-if="uniqueStudents.loading || uniqueCounselors.loading"
      width="280px"
      height="20px"
    />
    <div v-else id="sessionsListSubtitle">
      
      <p v-if="timeframe === 'upcoming'" class="body full-width">
        {{ studentCountText }} with at least one upcoming session
        <span v-if="outOfPocketCount">
          and {{ outOfPocketCountText }} paid for sessions
        </span>
      </p>

      <p v-else class="body full-width">
        <span v-if="filtered === 'all'">
          {{ studentCountText }} scheduled sessions
          <span v-if="outOfPocketCount">
            and {{ outOfPocketCountText }} paid for sessions
          </span>
        </span>
        <span v-if="filtered === 'successful'">
          {{ studentCountText }} conducted sessions
          <span v-if="outOfPocketCount">
            and {{ outOfPocketCountText }} paid for sessions
          </span>
        </span>

        <span v-else-if="filtered === 'canceled'">
          {{ studentCountText }} and {{ counselorCountText }} 
          canceled a session
        </span>

        <span v-else-if="filtered === 'not attended'">
          {{ studentCountText }} and {{ counselorCountText }} 
          failed to attend a scheduled session
        </span>

        <span v-if="timeframe === 'recent'">
          in the past 30 days
        </span>
        <span v-if="timeframe === 'pickRange'">
          in the selected range
        </span>
      </p>
    </div>
  </div>
</template>

<script>
import Skeleton from '../../../Skeleton.vue';
export default {
  components: {
    Skeleton
  },
  inject: [
    'uniqueStudents',
    'uniqueCounselors',
    'outOfPocketStudents'
  ],
  props:{
    timeframe: {
      type: String,
      required: true
    },
    filtered: {
      type: String,
      required: true
    },
  },
  computed: {
    title(){
      if (this.timeframe === 'upcoming') {
        return 'Upcoming Sessions';
      }

      if (this.timeframe === 'recent') {
        return `${this.filtered} Sessions ― Past 30 Days`;
      }

      return `${this.filtered} Sessions`;
    },
    studentCountText(){
      return this.pluralize(this.uniqueStudents.count, 'user');
    },
    counselorCountText(){
      return this.pluralize(this.uniqueCounselors.count, 'counselor');
    },
    outOfPocketCountText(){
      return this.pluralize(this.outOfPocketStudents.count, 'user');
    },
    outOfPocketCount(){
      return this.outOfPocketStudents.count;
    }
  },
  methods:{
    pluralize(num, string) {
      if (num === 1) {
        return `${num} ${string}`;
      }

      return `${num} ${string}s`;
    },
  }
}
</script>

<style>
</style>